import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.auth.bearerToken().pipe(
      switchMap((token) => {
        if (
          token &&
          (request.url.startsWith(environment.api.studentRoot) ||
            request.url.startsWith(environment.api.root) ||
            request.url.startsWith(environment.api.notificationsRoot) ||
            request.url.startsWith(environment.api.config))
        ) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }
        return next.handle(request);
      })
    );
  }
}
